import './backdrop.style.scss';

type BackdropProps = {
  isOpen: boolean;
  onClick?: () => void;
  disableBackdropColor?: boolean;
};

export const Backdrop = ({ isOpen, onClick, disableBackdropColor }: BackdropProps) => {
  if (!isOpen) return null;

  const handleOnClick = () => {
    onClick && onClick();
  };

  const getStyle = (): string => {
    let style = 'top-bar-backdrop';
    if (!disableBackdropColor) style = `${style} top-bar-backdrop-color`;
    return style;
  };

  return <div className={getStyle()} role='presentation' contentEditable onClick={handleOnClick} />;
};
